import * as React from 'react'
import './index.scss'
import { connect } from "react-redux";
import { ActionType, CHAINTYPES, reducerStoreType } from "../../reducers/types";
import { Dispatch } from "redux";
import Cashier from "./Cashier";
import LatestLink from "./LatestLink";
import Grid from "@material-ui/core/Grid";

interface IProps {
  dispatch: Dispatch<ActionType<undefined>>,
  currency?: string,
  chainType: CHAINTYPES,
  currentStore: number
}

class CreateLink extends React.Component<IProps, {}> {
  public render() {
    // const superView = (this.props.chainType === CHAINTYPES.CHAIN_STORE &&
    //     this.props.currentStore === -1
    //     && this.props.role === ROLES.SUPER_ADMIN)
    return (
      <div className="dashBoard">
        <Grid container spacing={2}>
          <Cashier />
          <LatestLink />
        </Grid>
      </div>
    );
  }
}

export default connect((state: reducerStoreType) => {
  return {
    indexStat: state.dashboard.indexStat,
    currency: state.app.userInfo ? state.app.userInfo.currency : '',
    chainType: state.merchant.merchantInfo.chainType,
    currentStore: state.app.currentStore
  }
})(CreateLink)